import React, { useState } from "react";
import logo from "./../../assets/logoins.png";
import { ButtonStyle } from "../../utils/Buttons/Buttons";
import Radio from "@mui/material/Radio";
import {useHistory} from 'react-router-dom'


import "./OVamosAfiliacion.scss";

function OVamosAfiliacion() {
  const history = useHistory();
  
  
  const NextOptions1= () => {
    history.push('./QVerificacionAfiliacion'+ history.location.search)
  };
  const NextOptions2= () => {
    history.push('./HQueDeseaHacer'+ history.location.search)
  };
  return (
    <div className="screen1">
      <div className="box_one" style={{marginBottom:'2em', marginTop: "20vh"}}>
        <p className="title2">Vamos a realizar <br/> una afiliación</p>
      

      </div>

   
      <div style={{ marginTop: "3em" }}>
        <ButtonStyle
          text="CONTINUAR"
           onClick={() => NextOptions1()}
          width="177px"
          height="5vh"
        />
         </div>
        <div style={{ marginTop: "1em" }}>
       
        <ButtonStyle
          text="VOLVER"
           onClick={() => NextOptions2()}
          width="177px"
          height="5vh"
        />
      </div>
    </div>
  );
}
export default OVamosAfiliacion;
